import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Paragraph
 *
 * This component is in charge of displaying
 * a page paragraph
 *
 * @return {jsx}
 */

const Paragraph = ({ className, children }) => <h1 className={className}>{children}</h1>;

/**
 * Display Name
 */
Paragraph.displayName = 'Page.Paragraph';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Paragraph.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Paragraph.defaultProps = {
  className: '',
  children: null,
};

export default styled(Paragraph)`
  font-size: ${({ theme: { fonts } }) => fonts.size.big};

  margin-bottom: 2.4rem;
`;



// WEBPACK FOOTER //
// ./src/components/Page/Paragraph/index.js